import {Component, OnInit} from "@angular/core";
import {WpcheckRequestService} from "../services/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {EmbedService} from "../../services/embed.service";
import {StepService} from "../../services/step.service";
import {WpcheckAnfrage} from "../anfrage/wpcheck.anfrage";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";

/**
 * Component for the entry of the wpcheck.
 */
@Component({
    selector: 'app-wpcheck-einstieg',
    templateUrl: './einstieg.component.html',
    standalone: false
})
export class EinstiegComponent implements OnInit {

  /**
   * constructor
   * @param requestService
   * @param router
   * @param route
   * @param elementService
   * @param activatedroute
   * @param portalService
   * @param embedService
   * @param stepService
   */
  constructor(private requestService: WpcheckRequestService, private router: Router, private route: ActivatedRoute,
              private elementService: ElementService, private activatedroute: ActivatedRoute, private  portalService: PortalService,
              private embedService: EmbedService, private stepService: StepService) {
  }

  /**
   * formfield for saving the nutzungstyp
   * @private
   */
  private static readonly FIELD_NUTZUNGSTYP: string = 'nutzungstyp';

  /**
   * List of nutzungstyps that we want to ask the user for
   */
  nutzungstypList = ['hauseigentuemer', 'wohnungseigentuemer', 'hausverwalter', 'mieter'];

  /**
   * the current userdata
   */
  anfrage: WpcheckAnfrage;

  /**
   * form for validation
   */
  form: UntypedFormGroup;

  /**
   * target of the link of the short version
   */
  shortVersionButtonUrl: string;

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    // url for short version
    this.activatedroute.data.subscribe(data => {
      // try to get button URL from the portal config, fallback to local URL if it is not there
      this.shortVersionButtonUrl = this.portalService.getConfig('wpcheck.short.buttonlink');
      if (this.shortVersionButtonUrl === null) {
        this.shortVersionButtonUrl = this.router.url + '/../start';
      }
    });

    this.activatedroute.queryParams.subscribe(params => {
      if (params?.step === 'basisdaten2') {
        this.nextStep();
      }
    });

    // get the anfrage from the local cache
    this.anfrage = this.requestService.getAnfrage();
    // initialize the form
    this.initForm();
  }

  /**
   * Inits the form with all the needed input fields.
   * @private
   */
  private initForm(): void {
    // create form and add inputs
    this.form = new UntypedFormGroup({});
    this.form.addControl(EinstiegComponent.FIELD_NUTZUNGSTYP, new UntypedFormControl(this.anfrage.userInput.nutzungstyp, [Validators.required]));
  }

  /**
   * The form is submitted
   *
   */
  onSubmit(): void {
    if (this.form.valid === true) {
      this.saveData();

      // show next Step
      this.nextStep();
    }
  }

  /**
   * save the selection of nutzungstyp
   */
  saveData(): void {
    // in some cases we can have no nutzungstyp, because the user did not choose one. Fallback here.
    if (this.form.get(EinstiegComponent.FIELD_NUTZUNGSTYP).value === null) {
      this.form.get(EinstiegComponent.FIELD_NUTZUNGSTYP).setValue(this.nutzungstypList[0]);
    }

    // save data to local browser
    this.anfrage.userInput.nutzungstyp = this.form.get(EinstiegComponent.FIELD_NUTZUNGSTYP).value;
    this.requestService.setAnfrage(this.anfrage);

    // save to server
    this.requestService.saveDataToServer();
  }

  /**
   * move to the next step
   */
  nextStep(): void {
    // forward to second input step
    this.router.navigate(['../eingabe/basisinformationen/2'], {relativeTo: this.route});
  }

}
